import produce from 'immer';

const INITIAL_STATE = {
  loadingTabs: false,
  IdMenu: null,
  tabs_consulta_pos_pagamento: [],
};

export default function posPagamentoContrato(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@posPagamentoContrato/LOAD_TABS_CONSULTA_REQUEST': {
        draft.loadingTabs = true;
        draft.IdMenu = null;
        break;
      }

      case '@posPagamentoContrato/LOAD_TABS_CONSULTA_SUCCESS': {
        draft.tabs_consulta_pos_pagamento = action.payload.tabs;
        draft.loadingTabs = false;
        draft.IdMenu = action.payload.IdMenu;
        break;
      }

      case '@posPagamentoContrato/LOAD_TABS_CONSULTA_FAILURE': {
        draft.tabs_consulta_pos_pagamento = [];
        draft.loadingTabs = false;
        break;
      }

      case '@posPagamentoContrato/SET_CURRENT_FILA': {
        draft.currentFila = action.payload;
        break;
      }

      default:
    }
  });
}
